import React from 'react';
import { styled as styled2 } from '@compiled/react';
import Heading from '@atlaskit/heading';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	listName: string;
};

const ConditionHeaderComponent = ({ listName }: Props) => {
	const { formatMessage } = useIntl();
	return (
		<>
			<Heading level="h200">
				{/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ stop: MessageDescriptorV2; pause: MessageDescriptorV2; start: MessageDescriptorV2; }'. */}
				<HeaderColumn>{formatMessage(messages[listName])}</HeaderColumn>
			</Heading>
			<DividerLine />
		</>
	);
};

export const ConditionHeader = ConditionHeaderComponent;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const HeaderColumn = styled2.div({
	paddingTop: token('space.100', '8px'),
	flexDirection: 'row',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N300),
	marginBottom: token('space.100', '8px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DividerLine = styled2.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	borderBottom: `2px solid ${token('color.border', colors.N40)}`,
	width: '100%',
	marginBottom: token('space.100', '8px'),
});
